import angular = require("angular");

export class AccessRouteController {
   static $inject = ["$routeParams"];
   title;
   type;
   constructor($routeParams) {

     switch ($routeParams.which) {
       case "401":
         this.type = "401";
         this.title = "ACCESS_ROUTE.ERROR_401";
         break;
       case "403":
         this.type = "403";
         this.title = "ACCESS_ROUTE.ERROR_403";
         break;
       case "404":
         this.type = "404";
         this.title = "ACCESS_ROUTE.ERROR_404";
         break;
       default:
         this.type = "400";
         this.title = "ACCESS_ROUTE.ERROR_400";
     }
   }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/controllers/accessRouteErr.ts
 **/